import { render } from "./AlbumCard.vue?vue&type=template&id=85da84be&scoped=true"
import script from "./AlbumCard.vue?vue&type=script&lang=js"
export * from "./AlbumCard.vue?vue&type=script&lang=js"

import "./AlbumCard.vue?vue&type=style&index=0&id=85da84be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85da84be"]])

export default __exports__